export default __webpack_public_path__ + "static/nepean454-hero-f56912645b28a60a79bbfb39fa755c39.jpg";